export default __webpack_public_path__ + "static/media/navigation-Header-Mobile.01cf12e6.jpg";